import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { useTranslation } from "react-i18next"
import { ArrowRight, CheckRead } from "@solar-icons/react"

const BENEFIT_KEYS = ["trial", "noCard", "cancel"] as const

export function CTASection() {
  const { t } = useTranslation("marketing")

  return (
    <section className="py-20 sm:py-32 bg-gradient-to-r from-teal-500 to-cyan-600 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
            {t("cta.title")}
          </h2>
          <p className="mt-4 text-lg opacity-90">
            {t("cta.subtitle")}
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button size="lg" className="rounded-full bg-white text-teal-600 hover:bg-teal-50" asChild>
              <Link to="/sign-up">
                {t("cta.getStarted")}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="rounded-full border-white/30 text-white hover:bg-white/10"
              asChild
            >
              <Link to="/contact">
                {t("cta.talkToSales")}
              </Link>
            </Button>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-6">
            {BENEFIT_KEYS.map((benefit) => (
              <div key={benefit} className="flex items-center gap-2 text-sm">
                <CheckRead className="h-4 w-4" />
                <span>{t(`cta.benefits.${benefit}`)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
